/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AttributeValueList } from '../model/attributeValueList';
import { AttributeValueListCreateRequest } from '../model/attributeValueListCreateRequest';
import { AttributeValueListKeys } from '../model/attributeValueListKeys';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class AttributeValueListService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createAttributeValueList
     * Creates a new attribute value list. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param attributeValueListCreateRequest the information needed to create an attribute value list
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public attributeValueListCreateAttributeValueList(attributeValueListCreateRequest: AttributeValueListCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<AttributeValueList>;
    public attributeValueListCreateAttributeValueList(attributeValueListCreateRequest: AttributeValueListCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AttributeValueList>>;
    public attributeValueListCreateAttributeValueList(attributeValueListCreateRequest: AttributeValueListCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AttributeValueList>>;
    public attributeValueListCreateAttributeValueList(attributeValueListCreateRequest: AttributeValueListCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (attributeValueListCreateRequest === null || attributeValueListCreateRequest === undefined) {
            throw new Error('Required parameter attributeValueListCreateRequest was null or undefined when calling attributeValueListCreateAttributeValueList.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AttributeValueList>(`${this.configuration.basePath}/attributeValueLists`,
            attributeValueListCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteAttributeValueList
     * Deletes an existing attribute value list. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the attribute value list
     * @param attributeValueListName the name of the attribute value list
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public attributeValueListDeleteAttributeValueList(namespace: string, attributeValueListName: string, observe?: 'body', reportProgress?: boolean): Observable<AttributeValueList>;
    public attributeValueListDeleteAttributeValueList(namespace: string, attributeValueListName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AttributeValueList>>;
    public attributeValueListDeleteAttributeValueList(namespace: string, attributeValueListName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AttributeValueList>>;
    public attributeValueListDeleteAttributeValueList(namespace: string, attributeValueListName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling attributeValueListDeleteAttributeValueList.');
        }
        if (attributeValueListName === null || attributeValueListName === undefined) {
            throw new Error('Required parameter attributeValueListName was null or undefined when calling attributeValueListDeleteAttributeValueList.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<AttributeValueList>(`${this.configuration.basePath}/attributeValueLists/namespaces/${encodeURIComponent(String(namespace))}/attributeValueListNames/${encodeURIComponent(String(attributeValueListName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAttributeValueList
     * Gets an existing attribute value list. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the attribute value list
     * @param attributeValueListName the name of the attribute value list
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public attributeValueListGetAttributeValueList(namespace: string, attributeValueListName: string, observe?: 'body', reportProgress?: boolean): Observable<AttributeValueList>;
    public attributeValueListGetAttributeValueList(namespace: string, attributeValueListName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AttributeValueList>>;
    public attributeValueListGetAttributeValueList(namespace: string, attributeValueListName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AttributeValueList>>;
    public attributeValueListGetAttributeValueList(namespace: string, attributeValueListName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling attributeValueListGetAttributeValueList.');
        }
        if (attributeValueListName === null || attributeValueListName === undefined) {
            throw new Error('Required parameter attributeValueListName was null or undefined when calling attributeValueListGetAttributeValueList.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AttributeValueList>(`${this.configuration.basePath}/attributeValueLists/namespaces/${encodeURIComponent(String(namespace))}/attributeValueListNames/${encodeURIComponent(String(attributeValueListName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAttributeValueLists
     * Gets a list of keys for all attribute value lists registered in the system that user has access to. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public attributeValueListGetAttributeValueLists(observe?: 'body', reportProgress?: boolean): Observable<AttributeValueListKeys>;
    public attributeValueListGetAttributeValueLists(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AttributeValueListKeys>>;
    public attributeValueListGetAttributeValueLists(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AttributeValueListKeys>>;
    public attributeValueListGetAttributeValueLists(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AttributeValueListKeys>(`${this.configuration.basePath}/attributeValueLists`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
